(function () {
  var SLIDE_INTERVAL_MS = 6000;
  var DESKTOP_BREAKPOINT = 768;
  var ITEMS_PER_PAGE_DESKTOP = 3;
  var ITEMS_PER_PAGE_MOBILE = 1;

  function buildCard(review) {
    var card = document.createElement('div');
    card.className = 'pdp-yotpo-reviews__card';

    var title = document.createElement('h3');
    title.className = 'pdp-yotpo-reviews__card-title';
    title.textContent = review.title || (review.content || '').slice(0, 60);

    var body = document.createElement('p');
    body.className = 'pdp-yotpo-reviews__card-body';
    body.textContent = review.content || '';

    var author = document.createElement('cite');
    author.className = 'pdp-yotpo-reviews__card-author';
    author.textContent = '— ' + ((review.user && review.user.display_name) || 'Verified Buyer');

    card.appendChild(title);
    card.appendChild(body);
    card.appendChild(author);
    return card;
  }

  function buildPage(reviews) {
    var page = document.createElement('div');
    page.className = 'pdp-yotpo-reviews__slide';
    reviews.forEach(function (review) {
      page.appendChild(buildCard(review));
    });
    return page;
  }

  function initSlider(root) {
    var sliderEl = root.querySelector('[data-yotpo-slider]');
    var trackEl = root.querySelector('[data-yotpo-slider-track]');
    var prevBtn = root.querySelector('[data-yotpo-prev]');
    var nextBtn = root.querySelector('[data-yotpo-next]');
    var timer = null;
    var index = 0;
    var pageCount = 0;

    function goTo(newIndex) {
      if (!pageCount) return;
      index = ((newIndex % pageCount) + pageCount) % pageCount;
      trackEl.style.transform = 'translateX(-' + index * 100 + '%)';
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (pageCount > 1) {
        timer = setInterval(function () {
          goTo(index + 1);
        }, SLIDE_INTERVAL_MS);
      }
    }

    function manualGoTo(newIndex) {
      goTo(newIndex);
      start();
    }

    function setReviews(reviews) {
      stop();
      trackEl.innerHTML = '';
      index = 0;

      if (!reviews.length) {
        pageCount = 0;
        sliderEl.hidden = true;
        return;
      }

      var itemsPerPage = window.innerWidth >= DESKTOP_BREAKPOINT ? ITEMS_PER_PAGE_DESKTOP : ITEMS_PER_PAGE_MOBILE;

      for (var i = 0; i < reviews.length; i += itemsPerPage) {
        trackEl.appendChild(buildPage(reviews.slice(i, i + itemsPerPage)));
      }
      pageCount = trackEl.children.length;

      trackEl.style.transform = 'translateX(0%)';
      sliderEl.hidden = false;

      if (prevBtn) prevBtn.hidden = pageCount <= 1;
      if (nextBtn) nextBtn.hidden = pageCount <= 1;

      start();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { manualGoTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { manualGoTo(index + 1); });

    sliderEl.addEventListener('mouseenter', stop);
    sliderEl.addEventListener('mouseleave', start);
    sliderEl.addEventListener('touchstart', stop, { passive: true });
    sliderEl.addEventListener('touchend', start);

    return { setReviews: setReviews };
  }

  function initReviews(root) {
    var appKey = root.dataset.yotpoAppKey;
    var productId = root.dataset.yotpoProductId;
    var emptyEl = root.querySelector('[data-yotpo-empty]');
    var slider = initSlider(root);

    if (!appKey || !productId) {
      if (emptyEl) emptyEl.hidden = false;
      return;
    }

    var endpoint =
      'https://api.yotpo.com/v1/widget/' +
      encodeURIComponent(appKey) +
      '/products/' +
      encodeURIComponent(productId) +
      '/reviews.json?per_page=24&page=1';

    fetch(endpoint)
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var reviews = (data && data.response && data.response.reviews) || [];
        slider.setReviews(reviews);
        if (!reviews.length && emptyEl) emptyEl.hidden = false;
      })
      .catch(function () {
        if (emptyEl) emptyEl.hidden = false;
      });
  }

  document.querySelectorAll('.pdp-yotpo-reviews').forEach(initReviews);
})();
